import { SxProps, useMediaQuery } from '@mui/material';

type Size = 'short' | 'medium' | 'large';

type Props = {
  size?: 'medium' | 'large';
  slots?: number; // quantity of internal sub-components (1 = normal, 2 = phone combo, etc.)
  base?: {
    sm?: number;
    md?: number;
  };
};

const SIZE_FACTOR: Record<Size, number> = {
  short: 1,
  medium: 1.44,
  large: 2,
};

const PADDING_X = 32;
const GAP_BETWEEN_SLOTS = 8;
const SLOT_WIDTH_SM = 136;
const SLOT_WIDTH_MD = 164;

export function useFormFieldStyles(props: Props = {}): SxProps {
  const size: Size = props.size ?? 'short';
  const slots = props.slots ?? 1;

  const sm = useMediaQuery('(max-width:500px)');

  // custom bases
  const baseSm = props.base?.sm ?? 0;
  const baseMd = props.base?.md ?? 0;

  const baseSlotWidth = sm ? SLOT_WIDTH_SM : SLOT_WIDTH_MD;
  const baseExtra = sm ? baseSm : baseMd;

  // Formula to calculate minWidth:
  const minWidthNumber = baseExtra + PADDING_X + (slots - 1) * GAP_BETWEEN_SLOTS + slots * baseSlotWidth;
  const minWidthNumberScaled = minWidthNumber * SIZE_FACTOR[size];

  return {
    flex: SIZE_FACTOR[size],
    minWidth: `${minWidthNumberScaled}px`,
  };
}

// OBS: previous simpler version, saved for reference
// import { SxProps, useMediaQuery, useTheme } from '@mui/material';
// type Props = {
//   size?: 'medium' | 'large';
// };
// export function useFormFieldStyles(props: Props): SxProps {
//   const size = props.size ?? 'short';
//   const theme = useTheme();
//   const sm = useMediaQuery(theme.breakpoints.down('sm'));
//   const SIZE_MAP: Record<string, SxProps> = {
//     short: {
//       flex: 1,
//       minWidth: sm ? '176px' : '256px',
//     },
//     medium: {
//       flex: 1.75,
//       minWidth: sm ? '240px' : '320px',
//     },
//     large: {
//       flex: 3.5,
//       minWidth: sm ? '300px' : '420px',
//     },
//   };
//   return SIZE_MAP[size];
// }
